import { Container } from 'unstated';
import { isEmpty } from 'validator';

export interface ISupplierDetailState {
  supplier: GQL.ISupplier;
  errors: IValidationErrors;
}

export interface ISupplierDetailStateProps {
  supplier: GQL.ISupplier;
}

export interface IValidationErrors {
  name: string | undefined;
}

export class StateContainer extends Container<ISupplierDetailState> {

  constructor(props: ISupplierDetailStateProps) {
    super();

    this.state = {
      supplier: props.supplier,
      errors: {} as IValidationErrors
    };
  }

  public async onChange(key: string, val: any) {
    await this.setState({
      supplier: { ...this.state.supplier, [key]: val }
    });
  }

  public async onChangeMany(pairs: Array<{ key: string; val: any }>) {
    for (const pair of pairs) {
      await this.onChange(pair.key, pair.val);
    }
  }

  public async validate(): Promise<IValidationErrors> {
    const { supplier } = this.state;
    const errors = { ...this.state.errors };
    const message = 'This field is required';

    const validateEmpty = (input: string) => {
      if (input == undefined || isEmpty(input)) {
        return message;
      } else {
        return undefined;
      }
    };

    errors.name = validateEmpty(supplier.name || '');
    await this.setState({ errors: errors });
    return errors;
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Suppliers/SupplierDetail/StateContainer.ts